import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Updates the rank of an item when a new item was added or moved
 * to the location described by the `rank` and `parentId` params.
 * Ranks are currently "local", i.e. scoped to a single `parentId` level.
 * The number of inserted items must be passed to `insertedItemCount`.
 */

export function adjustItemRankAfterInsertion(_ref) {
  var item = _ref.item,
    targetParentId = _ref.targetParentId,
    targetRankInSection = _ref.targetRankInSection,
    insertedItemCount = _ref.insertedItemCount;
  // If the item has the same parent and the same or a higher rank as the new item,
  // we need to update its rank
  if (item.parent_id === targetParentId && item.rankInSection >= targetRankInSection) {
    return _objectSpread(_objectSpread({}, item), {}, {
      rankInSection: item.rankInSection + insertedItemCount
    });
  } else {
    return item;
  }
}

/**
 * Adds a new item and updates the ranks of other items, if needed
 */

export function addItemAndRecalculateRanksInSection(items, newItem) {
  return [].concat(_toConsumableArray(items.map(function (item) {
    return adjustItemRankAfterInsertion({
      item: item,
      targetParentId: newItem.parent_id,
      targetRankInSection: newItem.rankInSection,
      insertedItemCount: 1
    });
  })), [newItem]);
}